import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'
import App from './App'
import TeleprompterMain from './Tool/TeleprompterMain';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
<TeleprompterMain/>
  </React.StrictMode>
);
